export function setSEO({
  title,
  description,
  image,
  url,
}) {
  document.title = title || 'أحمد المحيسني العقارية';

  const clearDescription = escapeHtml(description);

  setMeta('description', clearDescription);
  setMeta('og:title', title, 'property');
  setMeta('og:description', clearDescription, 'property');
  if(image){
    setMeta('og:image', image, 'property');
    setMeta('twitter:image', image);
  }
  setMeta('og:url', url, 'property');
  setMeta('og:type', 'website', 'property');

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', title);
  setMeta('twitter:description', clearDescription);
}

function setMeta(name, content, attribute = 'name') {
  let element = document.head.querySelector(
    `meta[${attribute}="${name}"]`
  );

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content || '');
}

function escapeHtml(value = '') {
  const clearData = String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  if(clearData.length > 200)
    return clearData.substring(0, 200);
  return clearData;
}
